<template>
  <v-app>
    <AppHeader :board="currentBoard" />

    <v-main>
      <BoardView :board="currentBoard"></BoardView>
    </v-main>
  </v-app>
</template>

<script>
import * as api from "./api";
import BoardView from "./BoardView";
import AppHeader from "./AppHeader";

export default {
  name: "App",
  components: {
    BoardView,
    AppHeader,
  },

  data: () => ({
    isInitializing: true,
    newBoardTitle: "",
    boards: [],
  }),
  computed: {
    currentBoard() {
      return this.boards.find((b) => b.id === this.$route.params.id) || {};
    },
  },

  mounted() {},
  methods: {
    async init() {
      this.boards = await api.getBoards();
      this.isInitializing = false;
    },
    boardChange(boardIdx) {
      this.currentBoard = this.boards[boardIdx] || { id: "none" };
    },
  },

  created() {
    this.init();
  },
};
</script>
